import { gql } from '@apollo/client';

export const CREATE_MODEL_CONVERSATION = gql`
  mutation CreateModelConversation($modelId: String!, $partner: String!) {
    createModelConversation(modelId: $modelId, partner: $partner) {
      id
      modelId
      partner
      createdAt
      lastMessageAt
    }
  }
`;

export const CREATE_AGENT_CONVERSATION = gql`
  mutation CreateAgentConversation($agentName: String!, $partner: String!) {
    createAgentConversation(agentName: $agentName, partner: $partner) {
      id
      agentName
      partner
      createdAt
      lastMessageAt
    }
  }
`;

export const DELETE_CONVERSATION = gql`
  mutation DeleteConversation($id: String!) {
    deleteConversation(id: $id)
  }
`;

export const SEND_MODEL_MESSAGE = gql`
  mutation SendModelMessage(
    $conversationId: String!
    $message: String!
    $messages: [MessageInput!]!
    $modelId: String!
    $partner: String!
  ) {
    sendModelMessage(
      conversationId: $conversationId
      message: $message
      messages: $messages
      modelId: $modelId
      partner: $partner
    ) {
      role
      content
    }
  }
`;

export const SEND_AGENT_MESSAGE = gql`
  mutation SendAgentMessage(
    $conversationId: String!
    $message: String!
    $messages: [MessageInput!]!
    $agentName: String!
    $partner: String!
    $aliasName: String
    $aliasVersion: String
  ) {
    sendAgentMessage(
      conversationId: $conversationId
      message: $message
      messages: $messages
      agentName: $agentName
      partner: $partner
      aliasName: $aliasName
      aliasVersion: $aliasVersion
    ) {
      jobId
      aliasName
      aliasVersion
    }
  }
`;

export const POLL_AGENT_JOB_RESULT = gql`
  mutation PollAgentJobResult($jobId: String!, $partner: String!) {
    pollAgentJobResult(jobId: $jobId, partner: $partner) {
      status
      role
      content
      resolvedAlias
      resolvedVersion
      errorReason
    }
  }
`;

export const GET_AGENTS = gql`
  query GetAgents {
    agentsList {
      id
      name
      description
      modelId
      capabilities
      status
      createdAt
      updatedAt
      agentArn
      agentId
      agentName
      agentVersion
      foundationModel
      promptOverrideConfiguration
      agentInstructions
      versionDetails
      clientToken
      customerEncryptionKeyArn
      knowledgeBases
      actionGroups
      agentResourceRoleArn
      idleSessionTTLInSeconds
      aliasId
      aliasName
      aliases {
        id
        name
        status
        description
      }
      agentStatus
      failureReasons
      sessionTimeout
    }
  }
`;

export const GET_AVAILABLE_RISK_AGENTS = gql`
  query GetAvailableRiskAgents {
    getAvailableRiskAgents
  }
`;

export const TRIGGER_RISK_AGENT = gql`
  mutation TriggerRiskAgent(
    $agentNames: [String!]!
    $entityId: String!
    $entityType: String!
    $reason: String!
    $executionType: AgentExecutionType
    $orchestrationExecutionId: String
    $partnerName: String
  ) {
    triggerRiskAgent(
      agentNames: $agentNames
      entityId: $entityId
      entityType: $entityType
      reason: $reason
      executionType: $executionType
      orchestrationExecutionId: $orchestrationExecutionId
      partnerName: $partnerName
    ) {
      agentName
      flowId
    }
  }
`;

export const GET_RISK_AGENT_RESPONSE = gql`
  query GetRiskAgentResponse(
    $agentNames: [String!]!
    $entityId: String!
    $entityType: String!
  ) {
    getAgentResponse(
      agentNames: $agentNames
      entityId: $entityId
      entityType: $entityType
    ) {
      agentName
      result
      status
      createdAt
    }
  }
`;

export const GET_ALIAS_DETAILS = gql`
  mutation GetAliasDetails($agentName: String!, $aliasName: String!) {
    getAliasDetails(agentName: $agentName, aliasName: $aliasName) {
      foundationModel
      agentInstructions
      aliasName
      aliasId
      agentVersion
      createdAt
      updatedAt
      guardrailConfiguration {
        guardrailIdentifier
        guardrailVersion
      }
    }
  }
`;
